import { backendAxios } from "../Services/axios";
import iReferralCode from "../models/iReferral";

export default class ReferralController {
  static async createReferralCode() {
    const response = await backendAxios.post("referral");
    return response.data;
  }

  static async getReferralCode(): Promise<iReferralCode> {
    const response = await backendAxios.get("referral");
    return response.data;
  }
}
